import { render, staticRenderFns } from "./ClassificationDialog.vue?vue&type=template&id=0f897b99&scoped=true&"
import script from "./ClassificationDialog.vue?vue&type=script&lang=js&"
export * from "./ClassificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationDialog.vue?vue&type=style&index=0&id=0f897b99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f897b99",
  null
  
)

export default component.exports